import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/Tools/ScrollToTop";

import "./app.css";
import Navbar from "./components/Navbar/Navbar";
import Main from "./components/Main/Main";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import HomeContent from "./components/HomeContent/homeContent";
import AboutUs from "./components/AboutUs/AboutUs";
import PopularTours from "./components/PopularTours/PopularTours";
import CategoryTours from "./components/CategoryTours/CategoryTours";
import SpecialOffers from "./components/SpecialOffers/SpecialOffers";
import Blog from "./components/Blog/Blog";
import FAQ from "./components/FAQ/FAQ";

import TailorMadeForm from "./components/Tailor/TailorMadeForm";
import Tourhome from "./components/TourHome/TourHome";
import Filter from "./components/Filter/Filter";
import TourMain from "./components/TourMain/TourMain";
import TourDetails from "./components/TourDeatils/TourDetails";
import PackageMain from "./components/PackageMain/PackageMain";
import PackageHome from "./components/PackageHome/PackageHome";
import Booking from "./components/Booking/Booking";
import BookingHome from "./components/BookingHome/BookingHome";
import AboutBanner from "./components/AboutBanner/AboutBanner";
import ContactUsBanner from "./components/ContactUsBanner/ContactUsBanner";
import ContactUs from "./components/ContactUs/ContactUs";
import FloatingWidgets from "./components/Tools/FloatingWidgets";
import { SettingsProvider } from "./components/SettingsContext";
import TourMainFiltered from "./components/TourMain/TourMainFiltered";

const App = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <SettingsProvider>
      <ScrollToTop />

      <Routes>
        {/* الصفحة الرئيسية */}
        <Route
          path="/"
          element={
            <>
              <Navbar />

              {/* زرار فتح المودال */}
              <div className="text-center my-6">
                <a
                  href="#"
                  className="theme-btn btn-style-three-spo"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(true);
                  }}
                >
                  Design Your Perfect Egypt Tour Now
                </a>
              </div>

              <Home />
              <HomeContent />
              <Main />
              <AboutUs />
              <PopularTours />
              <CategoryTours onOpenModal={() => setOpenModal(true)} />
              <SpecialOffers />
              <Blog />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />

        {/* باقي الصفحات */}
        <Route
          path="/packages"
          element={
            <>
              <Navbar />
              <PackageHome />
              <PackageMain onOpenModal={() => setOpenModal(true)} />
              <Blog />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />

        
       <Route
  path="/tours/:destination_id?"
  element={
    <>
      <Navbar />
      <Tourhome />
      <TourMain onOpenModal={() => setOpenModal(true)} />
      <Blog />
      <FAQ />
      <Footer />
      <FloatingWidgets />
    </>
  }
/>

        <Route
          path="/about-us"
          element={
            <>
              <Navbar />
              <AboutBanner />
              <AboutUs />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />

        <Route
          path="/tour-details/:id" 
          element={
            <>
              <Navbar />
              <TourDetails />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />

        <Route
          path="/booking"
          element={
            <>
              <Navbar />
              <BookingHome />
              <Booking />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />

        <Route
          path="/contact"
          element={
            <>
              <Navbar />
              <ContactUsBanner />
              <ContactUs />
              <FAQ />
              <Footer />
              <FloatingWidgets />
            </>
          }
        />
      </Routes>

      {/* المودال يبقى فوق كل الصفحات */}
      {openModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setOpenModal(false)}
            >
              ✖
            </button>
            <TailorMadeForm />
          </div>
        </div>
      )}
    </SettingsProvider>
  );
};

export default App;
